import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';
import CollectionGridItem from '../collection-components/collection-grid-item';

const RelatedProductsContainer = styled.div`
    padding: 100px 0;

    > .title-container {
        text-align: center;
        margin-bottom: 50px;
        h3 {
            font-size: 2rem;
            color: #000;
            font-family: 'neue-kabel', sans-serif;
        }
    }
    .related-products-grid {
        display: flex;
        flex-wrap: wrap;
        ${media.medium`max-width: 80vw;`}

        > * {
            flex: 0 0 50%;

            ${media.medium`flex: 0 0 25%;`}
        }
    }
`;

const RelatedProducts = ({ handle }) => {
    const data = useStaticQuery(graphql`
        query {
            allCollections: allShopifyCollection {
                edges {
                    node {
                        title
                        handle
                        products {
                            options {
                                name
                                values
                            }
                            availableForSale
                            priceRange {
                                maxVariantPrice {
                                    amount
                                }
                            }
                            handle
                            images {
                                id
                                altText
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 500) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                            productType
                            shopifyId
                            tags
                            title
                            variants {
                                compareAtPrice
                                availableForSale
                                price
                                selectedOptions {
                                    name
                                    value
                                }
                                shopifyId
                                image {
                                    altText
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 700) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const relatedCollection =
        data &&
        data.allCollections.edges.filter(
            (edgeNode) => edgeNode.node.handle === handle
        );

    console.log(relatedCollection);
    const relatedProducts =
        relatedCollection[0] && relatedCollection[0].node.products;
    return (
        <RelatedProductsContainer>
            <Wrapper className="title-container">
                <h3>You might also like these products.</h3>
            </Wrapper>

            <Wrapper className="related-products-grid">
                {relatedProducts &&
                    relatedProducts.slice(0, 4).map((product) => {
                        return (
                            <CollectionGridItem
                                product={product}
                                handle={relatedCollection[0].handle}
                            />
                        );
                    })}
            </Wrapper>
        </RelatedProductsContainer>
    );
};

export default RelatedProducts;
